import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'vias-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent {
  numLocale: string;
  question: string = 'confirmationProcess';
  is_note: boolean = false;
  confirmText: string = 'yes';
  rejectText: string = 'nope';
  @ViewChild('notes', { static: false }) public notes: ElementRef;
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { 
      if(data.is_note !== undefined){
        this.is_note = data.is_note;
      }
      if(data.question !== undefined){
        this.question = data.question;
      }
      if(data.confirmText !== undefined){
        this.confirmText = data.confirmText;
      }
      if(data.rejectText !== undefined){
        this.rejectText = data.rejectText;
      }
    }
    onNoYesClick(confirm): void {
      let data = {confirm: confirm};
      if(this.is_note){
        data['notes'] = this.notes.nativeElement.value;
      }
      this.dialogRef.close(data);
    }
}
